import {
    Typography,
    withStyles,
    withTheme,
  } from '@material-ui/core';
      
  import { FilteringState, IntegratedFiltering } from '@devexpress/dx-react-grid';
  import { Grid, Table, TableFilterRow, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
  import {
    IntegratedSorting,
    SortingState,
  } from '@devexpress/dx-react-grid';
      
  import { compose } from 'recompose';
  import React, { PureComponent } from 'react';
  import classNames from 'classnames';
      
  import { formatDateGeneric } from 'utilities/common';
  import Log from 'utilities/log';
  import Spinner from 'modules/common/spinner.component';

  import { connect } from 'react-redux';
      
  const styles = (theme) => {
    const intakeRecordBorder = `1px solid ${theme.palette.grey[500]}`;
    return {
      table: {
        borderSpacing: theme.spacing(0, 2),
      },
      tableHead: {
        height: 32,
      },
      cell: {
        borderTop: intakeRecordBorder,
        borderBottom: intakeRecordBorder,
        borderLeft: 0,
        borderRight: 0,
        '&:first-child': {
          borderTopLeftRadius: theme.shape.borderRadius,
          borderBottomLeftRadius: theme.shape.borderRadius,
          borderLeft: intakeRecordBorder,
        },
        '&:last-child': {
          borderTopRightRadius: theme.shape.borderRadius,
          borderBottomRightRadius: theme.shape.borderRadius,
          borderRight: intakeRecordBorder,
        },
      },
      urgencyMenuItem: {
        justifyContent: 'center',
      },
      selectInput: {
        lineHeight: 1.75,
        paddingBottom: theme.spacing(0.5),
        paddingRight: theme.spacing(4),
        paddingTop: theme.spacing(0.5),
      },
      row: {
        backgroundColor: theme.palette.common.white,
      },
      noDataCell: {
        paddingBottom: theme.spacing(12),
        paddingTop: theme.spacing(12),
        textAlign: 'center',
      },
    };
  };
      
  const FILTER_DISABLED_COLUMNS = ['organization'];
      
  class SurveyQuestionsGrid extends PureComponent {
        static defaultProps = {
          isLoading: false,
        };

        constructor(props) {
          super(props);
                
          this.state = {
            columns: [
              { name: 'surveyQuestionId', title: 'Question ID', getCellValue: (record) => <Typography>{record.surveyQuestion.surveyQuestionId}</Typography> },
              { name: 'questionName', title: 'Question Name', getCellValue: (record) => <Typography>{record.surveyQuestion.questionName}</Typography> },
              { name: 'version', title: 'Version', getCellValue: (record) => <Typography>{record.surveyQuestion.version}</Typography> },
              { name: 'statusId', title: 'Status', getCellValue: (record) => <Typography>{props.surveyStatuses.find((o) => o.id === record.surveyQuestion.statusId)?.title}</Typography> },
              // { name: 'categoryId', title: 'Category', getCellValue: (record) => <Typography>{categoryOptions.find((o) => o.id === record.category)?.title}</Typography> },
              // { name: 'primaryTriggerService', title: 'Service', getCellValue: (record) => <Typography>{serviceOptions.find((o) => o.id === record.primaryTriggerService)?.title}</Typography> },
              // { name: 'primaryTriggerField', title: 'Primary Trigger Field', getCellValue: (record) => <Typography>{fieldOptions.find((o) => o.id === record.primaryTriggerField)?.title}</Typography> },
              // { name: 'primaryTriggerValue', title: 'Primary Trigger Value'  },
            ],
            filters: [],
            sorting: [{ columnName: 'surveyQuestionId', direction: 'desc' }],
            integratedFilteringColumnExtensions: [
              { columnName: 'questionNa,e', predicate: this.keyPredicate },
            ],
          };
    
          this.changeSorting = (sorting) => this.setState({ sorting });
    
        }
  
        keyPredicate = (value, filter) => {
          const valueLower = (value.key || '').toLowerCase();
          const filterLower = (filter.value || '').toLowerCase();
          return valueLower.indexOf(filterLower) > -1;
        };
  
        formatDate = (key) => (record) => {
          return formatDateGeneric(record[key]);
        };
    
        cellClicked = (id) => {
          this.props.history.push(`/surveyQuestions/${id}`);
        }

        getNumExpenseLines = (record) => {
            const { expenseLines } = this.props;
            const lines = expenseLines.filter(instance => instance.expenseId === record.expenseId);
            return lines ? lines.length : 0;
        };
      
        changeFilters = (filters) => this.setState({ filters });
      
        filterCell = (props) => {
          return props.column.title && !FILTER_DISABLED_COLUMNS.includes(props.column.name) ?
            <TableFilterRow.Cell {...props} /> : null;
        };
      
        headerCell = (props) => {
          return props.column.title ? <TableHeaderRow.Cell {...props} /> : null;
        };
      
        headerRowComponent = (props) => {
          return <TableHeaderRow.Row className={this.props.classes.tableHead} {...props} />;
        };
      
        rowComponent = (props) => {
          return <Table.Row className={this.props.classes.row} {...props} />;
        };
      
        cellComponent = (props) => {
          let clickHandler = () => this.props.history.push(`/surveyQuestions/${props.row.surveyQuestion.surveyQuestionId}`); // Add handler for when a client is clicked
          let pointerClass = 'handles-click';
          const className = classNames(this.props.classes.cell, pointerClass);
          return <Table.Cell onClick={clickHandler} className={className} {...props} />;
        };
      
        tableComponent = (props) => {
          return <Table.Table className={this.props.classes.table} {...props} />;
        };
      
        noDataCellComponent = (props) => {
          const content = this.props.isLoading ? <Spinner logo /> : 'No Records were returned.  Check the filters above.';
          // need to remove the getMessage function to avoid exception
          // eslint-disable-next-line no-unused-vars
          const { getMessage, ...rest } = props;
          return (
            <Table.Cell {...rest} className={this.props.classes.noDataCell}>
              <Typography>{content}</Typography>
            </Table.Cell>
          );
        };
      
        
        render() {
          Log.trace('RENDER', 'surveyQuestionGrid');
          const { surveyQuestions } = this.props;
          const {
            columns,
            filters,
            tableColumnExtensions,
            integratedFilteringColumnExtensions,
            sorting,
          } = this.state;

          return (
            <Grid
              rows={surveyQuestions}
              columns={columns}
            >
              <SortingState
                sorting={sorting}
                onSortingChange={this.changeSorting}
              />
                
              <FilteringState
                filters={filters}
                onFiltersChange={this.changeFilters}
              />
              <IntegratedFiltering columnExtensions={integratedFilteringColumnExtensions} />
              <IntegratedSorting />
              <Table
                columnExtensions={tableColumnExtensions}
                rowComponent={this.rowComponent}
                tableComponent={this.tableComponent}
                cellComponent={this.cellComponent}
                noDataCellComponent={this.noDataCellComponent}
              />
              <TableHeaderRow rowComponent={this.headerRowComponent} cellComponent={this.headerCell} showSortingControls />
              <TableFilterRow cellComponent={this.filterCell} />
            </Grid>
          );
        }
  }
      
  const mapStateToProps = state => {
    const { surveyStatuses } = state.enumerations.allEnums;
    return {
      surveyStatuses: surveyStatuses
    };
  };
  
  export default compose(
    withStyles(styles),
    withTheme,
    connect(mapStateToProps, {
    })
  )(SurveyQuestionsGrid);
      